import { render, staticRenderFns } from "./Theme4TheFooter.vue?vue&type=template&id=38892a42&scoped=true&"
import script from "./Theme4TheFooter.vue?vue&type=script&lang=js&"
export * from "./Theme4TheFooter.vue?vue&type=script&lang=js&"
import style0 from "./Theme4TheFooter.vue?vue&type=style&index=0&id=38892a42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38892a42",
  null
  
)

export default component.exports